import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import * as qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

import type { ITranslateSourceData, ITranslateSourceDataListKeys } from '../model/translateSourceDataList';

export const translateSourceDataListKey = (
  keys?: ITranslateSourceDataListKeys,
): [string, string, Array<number> | undefined, string, ITableSorting | undefined] => [
  'translateSourceDataList',
  keys?.type || '',
  keys?.locationIds,
  keys?.search || '',
  keys?.sorting,
];

export const translateSourceDataListFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof translateSourceDataListKey>>) => {
  const orderBy = queryKey[4]?.id ? queryKey[4].id : undefined;
  const direction = !queryKey[4]?.id ? undefined : queryKey[4].desc ? 'desc' : 'asc';

  const params = {
    locationIds: queryKey[2],
    filters: {
      query: queryKey[3],
    },
    sort: {
      column: orderBy,
      direction: direction,
    },
  };

  return apiClient.get(`${APP_API_URL_V2}fsd/translate/source-data/${queryKey[1]}`, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params),
    },
  });
};

const translateSourceDataListSelect = ({ data }: AxiosResponse<{ data: ITranslateSourceData[] }>) =>
  data?.data || [];

export const useTranslateSourceDataListQuery = (keys: ITranslateSourceDataListKeys) => {
  return useQuery({
    queryKey: translateSourceDataListKey(keys),
    queryFn: translateSourceDataListFn,
    select: translateSourceDataListSelect,
  });
};
